import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface AssetTypeState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allAssetType: [] | null | any;
}
const initialState: AssetTypeState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allAssetType: null,
};
export const assetTypeSlice = createSlice({
  name: 'AssetType',
  initialState,
  reducers: {
    setAllAssetType: (state, action) => {
      state.allAssetType = action.payload.data;
    },
    setAssetType: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllAssetTypeBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setAllAssetType, setAssetType, setAllAssetTypeBySearch,reset } = assetTypeSlice.actions;
export const allAssetTypeDetails = (state: RootState) => state.assetType.allAssetType;
export const getAllAssetTypeDetails = (state: RootState) => state.assetType.data;
export const getAssetTypeTotalRecords=(state:RootState)=>state.assetType.totalRecords;
export const getAllAssetTypeBySearch = (state: RootState) => state.assetType.data;
export default assetTypeSlice.reducer;